<ng-container *ngrxLet="{tier: tier$, loggedIn: loggedIn$, loaded: loaded$, isPerMonth:isPerMonth$}; let vm">
  <div id="spout-checkout-container">
    <div id="spout-checkout-info">
      <ng-container *ngIf="vm.tier == PROMO">
        <h1>PROMOTIONAL PLAN</h1>
        <hr />
        Get all of the same features as a PERSONAL PLAN without any cost. <br />
      </ng-container>
      <ng-container *ngIf="vm.tier == PERSONAL">
        <h1>PERSONAL PLAN</h1>
        <hr />
        $10.00 / Month
        <br />
        $72.00 / Year
        <hr />
        1 GB<sup>*</sup>
        <hr />
        Can invite collaborators and reviewers to your project.
      </ng-container>
      <ng-container *ngIf="vm.tier == COLLABORATOR">
        <h1>COLLABORATOR PLAN</h1>
        <hr />
        Contribute to other projects only. All costs for contribution are the
        project owner's responsibility.
        <br />
        Must be invited to a project as a reviewer.
      </ng-container>
      <table>
        <tr>
          <td colspan="2" style="text-align: center; padding-top: 10px">
            DAW FEATURES
          </td>
        </tr>
        <tr>
          <td>
            Clear Tracks
            <span class="feature-description">( if creator of track )</span>
          </td>
          <td>✅</td>
        </tr>
        <tr>
          <td>Copy Tracks</td>
          <td>✅</td>
        </tr>
        <tr>
          <td>Create Mixes</td>
          <td>✅</td>
        </tr>
        <tr>
          <td>Create Projects</td>
          <td *ngIf="vm.tier != COLLABORATOR">✅</td>
          <td *ngIf="vm.tier == COLLABORATOR">❌</td>
        </tr>
        <tr>
          <td>Create Songs</td>
          <td *ngIf="vm.tier != COLLABORATOR">✅</td>
          <td *ngIf="vm.tier == COLLABORATOR">❌</td>
        </tr>
        <tr>
          <td>Create Tracks</td>
          <td>✅</td>
        </tr>
        <tr>
          <td>
            Delete Tracks
            <span class="feature-description">( if creator of track )</span>
          </td>
          <td>✅</td>
        </tr>
        <tr>
          <td>
            Export Song
            <span class="feature-description">( if creator of track )</span>
          </td>
          <td *ngIf="vm.tier != COLLABORATOR">✅</td>
          <td *ngIf="vm.tier == COLLABORATOR">❌</td>
        </tr>
        <tr>
          <td>Import Audio Files</td>
          <td>✅</td>
        </tr>
        <tr>
          <td>Record</td>
          <td>✅</td>
        </tr>
        <tr>
          <td>Track Controls</td>
          <td>✅</td>
        </tr>
        <tr>
          <td colspan="2" style="text-align: center; padding-top: 20px">
            COLLABORATION FEATURES
          </td>
        </tr>
        <tr>
          <td>Add Annotations</td>
          <td>✅</td>
        </tr>
        <tr>
          <td>Add Collaborators</td>
          <td *ngIf="vm.tier != COLLABORATOR">✅</td>
          <td *ngIf="vm.tier == COLLABORATOR">❌</td>
        </tr>
        <tr>
          <td>Chat</td>
          <td>✅</td>
        </tr>
        <tr>
          <td>Share Tracks</td>
          <td>✅</td>
        </tr>

        <tr>
          <td colspan="2" style="text-align: center; padding-top: 20px">
            ADD ONS
          </td>
        </tr>
        <tr>
          <td>Additional Storage</td>
          <td>$3.00 / 1 GB / month</td>
        </tr>
      </table>
    </div>
    <div id="spout-checkout-cart">
      <h1>CHECKOUT</h1>
      <ng-container *ngIf="vm.tier == PROMO">
        Fully featured for 3 months at no cost to you.
        <hr>
      </ng-container>
      <ng-container *ngIf="vm.loaded">
        <ng-container *ngIf="vm.tier != PROMO">
          <h2>PAYMENT SCHEDULE</h2>
          <input id="false" type="radio" [value]="false" name="schedule" (change)="UpdateCart(vm.isPerMonth)"
            [(ngModel)]="vm.isPerMonth" />YEARLY
          <br />
          <input id="true" type="radio" [value]="true" name="schedule" (change)="UpdateCart(vm.isPerMonth)"
            [(ngModel)]="vm.isPerMonth" />MONTHLY
          <h2>ADDITIONAL STORAGE</h2>
          <spt-addon-storage (quantityChange)="UpdateStorage($event)">
          </spt-addon-storage>
          <h2>SUMMARY</h2>
        </ng-container>
        <ng-container *ngIf="vm.tier == PROMO">
          <div class="total-cost">
            <h2>Total</h2>
            $0.00
          </div>
        </ng-container>
        <ng-container *ngIf="vm.tier != PROMO">
          <div class="total-cost">
            <h2>Total</h2>
            {{ GetTotal() | currency: "USD" }}
            <span class="time-period">{{ vm.isPerMonth == true ? "month" : "year" }}</span>
          </div>
        </ng-container>
        <button class="mat-focus-indicator mat-flat-button mat-button-base mat-primary ng-star-inserted"
          (click)="vm.loggedIn ? OnCheckOut() : Login()">
          CHECKOUT
        </button>
      </ng-container>
      <ng-container *ngIf="vm.loaded == false && vm.loggedIn== true">
        Loading ...
      </ng-container>
      <ng-container *ngIf="vm.loggedIn== false">
        <button class="mat-focus-indicator mat-flat-button mat-button-base mat-primary ng-star-inserted"
          (click)=" Login()">
          Sign In
        </button>
      </ng-container>
    </div>
  </div>
</ng-container>